import BookACallButton from '../Buttons/Specials/BookACallButton'

const CallAction = ({ CallActionButton = BookACallButton }) => {
    return (
        <div className="max-w-7xl mx-auto px-4">
            <div className="bg-olm-mid-yellow flex flex-col lg:flex-row justify-between rounded-lg shadow-lg text-center lg:text-left">
                <div className="flex justify-center lg:justify-start">
                    <img
                        src="/assets/coaching/call-action-left.png"
                        alt="envelope"
                        className="w-full lg:w-auto hidden md:block"
                    />
                    <img
                        src="/assets/coaching/mobile-call-action-left.png"
                        alt="envelope"
                        className="w-full lg:w-auto md:hidden"
                    />
                </div>
                <div className="py-4 z-10 md:py-12 px-4 lg:px-0 text-center">
                    <h2 className="text-4xl lg:text-5xl font-bold mb-4 space-x-1">
                        <span>Ready to elevate your</span>
                        <br className="hidden lg:block" />
                        <span className="olm-gradient-text">
                            direct mail strategy?
                        </span>
                    </h2>
                    <p className="text-lg mb-6 px-8 md:px-0">
                        <b>Book a Coaching Call Now </b> and start seeing the
                        results you’ve been aiming for!
                    </p>
                    <div className="max-w-xl md:w-96 w-full m-auto">
                        <CallActionButton />
                    </div>
                </div>
                <div className="flex rounded-lg relative justify-center lg:justify-end">
                    <img
                        src="/assets/coaching/call-action-right.png"
                        alt="envelope"
                        className="w-full rounded-lg lg:w-auto hidden md:block"
                    />
                    <img
                        src="/assets/coaching/mobile-call-action-right.png"
                        alt="envelope"
                        className="w-full rounded-lg lg:w-auto md:hidden -mt-20"
                    />
                </div>
            </div>
        </div>
    )
}

export default CallAction
